import type { ElementType } from 'react';
import {
  Bot,
  Database,
  Lock,
  MessageSquare,
  Server,
  Settings,
  Sparkles,
  Tag,
} from 'lucide-react';

export const MODULE_ICON_MAP: Record<string, ElementType> = {
  agents: Bot,
  skills: Sparkles,
  knowledge: Database,
  taxonomy: Tag,
  mcp: Server,
  secrets: Lock,
  conversations: MessageSquare,
  config: Settings,
};

export const MODULE_LABEL_KEY_MAP: Record<string, string> = {
  agents: 'admin.permissions.modules.labels.agents',
  skills: 'admin.permissions.modules.labels.skills',
  knowledge: 'admin.permissions.modules.labels.knowledge',
  taxonomy: 'admin.permissions.modules.labels.taxonomy',
  mcp: 'admin.permissions.modules.labels.mcp',
  secrets: 'admin.permissions.modules.labels.secrets',
  conversations: 'admin.permissions.modules.labels.conversations',
  config: 'admin.permissions.modules.labels.config',
};

export function getModuleLabelKey(moduleName: string): string | undefined {
  return MODULE_LABEL_KEY_MAP[moduleName];
}

export function humanizeModuleName(moduleName: string): string {
  return moduleName
    .split(/[_-]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}